import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LogService } from '../../logging/log.service';
import { NavigationService } from '../../navigation/navigation.service';
import { LocationContextService } from '../location-context.service';

@Component({
    selector: 'app-terminal-selection',
    templateUrl: './terminal-selection.component.html'
})
export class TerminalSelectionComponent implements OnInit, OnDestroy {
    LOG_SOURCE = 'TerminalSelectionComponent';

    sub: Subscription;

    terminals: string[];

    constructor(
        private readonly locationContextService: LocationContextService,
        private readonly navigationService: NavigationService,
        private readonly logService: LogService
    ) {}

    ngOnInit() {
        this.locationContextService.clearSelectedTerminal();

        this.locationContextService.requestTerminals();

        this.sub = this.locationContextService.getTerminals().subscribe(terminals => {
            this.terminals = terminals;

            this.navigationService.setTerminalOptionsCount(terminals.length);

            // Redirect automatically if only 1 option is available
            if (terminals.length === 1) {
                const terminal = terminals[0];

                this.logService.info(
                    this.LOG_SOURCE,
                    `Terminal '${terminal}' is selected automatically because it is the only available option`,
                    { terminal }
                );

                this.setSelectedTerminalAndRedirect(terminal, true);
            }
        });
    }

    setSelectedTerminalAndRedirect(terminal: string, singleTerminal: boolean) {
        this.logService.info(this.LOG_SOURCE, `Selected terminal '${terminal}'`, {
            terminal
        });
        this.locationContextService.setSelectedTerminal(terminal, singleTerminal);
        this.navigationService.redirectToCenterlineGroupSelection();
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
